/* eslint-disable */
import { put, select } from 'redux-saga/effects'
import GithubActions from '../Redux/GithubRedux'
import ReloginTypes from '../Redux/ReloginRedux'
import UserActions from '../Redux/UserRedux'
import { is } from 'ramda'

import { NavigationActions } from 'react-navigation'


// exported to make available for tests
export const selectAvatar = (state) => state.github.avatar

// process STARTUP actions
export const startup = function* startup(action) {
  console.log("startup saga")
  const resetAction = NavigationActions.reset({
    index: 0,
    key: null,
    actions: [
      NavigationActions.navigate({ routeName: 'auth' }),
    ],

  })
  console.log("ready for relogin request")
  yield put(ReloginTypes.reloginRequest())
  console.log("done relogin request")
  if (false && __DEV__ && console.tron) {
    // straight-up string logging

    // logging an object for better clarity
    console.tron.log({
      message: 'pass objects for better logging',
      someGeneratorFunction: selectAvatar
    })

    // fully customized!
    const subObject = { a: 1, b: [1, 2, 3], c: true }
    subObject.circularDependency = subObject // osnap!
    console.tron.display({
      name: '🔥 IGNITE 🔥',
      preview: 'You should totally expand this',
      value: {
        '💃': 'Welcome to the future!',
        subObject,
        someInlineFunction: () => true,
        someGeneratorFunction: startup,
        someNormalFunction: selectAvatar
      }
    })
  }

  /*
    console.tron.log("Getting avatar info")
    const avatar = yield select(selectAvatar)
    // only get if we don't have it yet
    if (!is(String, avatar)) {
      yield put(GithubActions.userRequest('GantMan'))
    }
  */
}
